/* eslint-disable no-else-return */
import {
  ACTION_BUTTONS_HEIGHT,
  ACTION_BUTTONS_WIDTH,
  PLACEMENTS,
} from "constants/discovery";
import { isPdf, isWord } from "utils";

export const NO_LOGICAL_GROUPING = "(no logical grouping)";

export const getSelectedDocs = (themes) => {
  return themes?.[0]?.Documents.filter((doc) => !doc.ignored) || [];
};

export const getSelectedTerms = (themes) => {
  return (
    themes
      ?.filter((theme) => theme.checked && theme.NounPhrase !== undefined)
      .map((item) => item.NounPhrase) || []
  );
};

export const getDocumentsWithTerms = (
  selectedDocs,
  selectedTerms,
  documentByContent
) => {
  if (documentByContent) {
    return selectedDocs.map((doc) => ({
      docId: doc.Id,
      selectedTerms: [],
    }));
  }

  return selectedDocs.map((doc) => ({
    docId: doc.Id,
    selectedTerms,
  }));
};

export const getCheckedThemes = (themes) => {
  return themes
    .filter((t) => t.NounPhrase && t.checked)
    .map((term) => ({
      group: term.GroupName,
      term: term.NounPhrase,
    }));
};

export const getFilteredThemes = (themes, showAll, isSearch, filterView) => {
  const isCheckedAndOrSearched = (element) => {
    if (!showAll && isSearch) {
      return element.checked && element.FilteredBySearch;
    }
    if (!showAll && filterView) {
      return element.checked && element.FilteredByFilter;
    }
    if (!showAll) {
      return element.checked;
    }
    if (isSearch) {
      return element.FilteredBySearch;
    }
    if (filterView) {
      return element.FilteredByFilter;
    }
    return false;
  };

  if (showAll && !isSearch && !filterView) {
    return [];
  }

  return themes
    .filter(
      (element) =>
        isCheckedAndOrSearched(element) &&
        element.GroupName !== "All Themes" &&
        element.NounPhrase !== undefined
    )
    .map((term) => ({
      group: term.GroupName,
      term: term.NounPhrase,
    }));
};

export const getExtensions = (selectedDocs) => {
  let pdfSelected = false;
  let wordSelected = false;

  selectedDocs.forEach((document) => {
    if (isPdf(document.Name)) {
      pdfSelected = true;
    }
    if (isWord(document.Name)) {
      wordSelected = true;
    }
  });

  return { pdfSelected, wordSelected };
};

export const getActionButtonsCoords = (parentRef, placement, alignBottom) => {
  const parentElement = parentRef?.current;
  let top = 0;
  let left = 0;

  if (parentElement === undefined) {
    return { top, left };
  }

  const box = parentElement.getBoundingClientRect();

  const { body } = document;
  const docEl = document.documentElement;

  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

  const clientTop = docEl.clientTop || body.clientTop || 0;
  const clientLeft = docEl.clientLeft || body.clientLeft || 0;

  if (alignBottom) {
    top = scrollTop - clientTop + box.bottom - ACTION_BUTTONS_HEIGHT;
  } else {
    top = scrollTop - clientTop + box.top;
  }

  const rightCoordinate = scrollLeft - clientLeft + box.left + box.width;
  if (placement === PLACEMENTS.LEFT) {
    left = scrollLeft - clientLeft + box.left - ACTION_BUTTONS_WIDTH;
  } else if (
    placement === PLACEMENTS.RIGHT &&
    rightCoordinate + ACTION_BUTTONS_WIDTH > window.innerWidth
  ) {
    top = scrollTop - clientTop + box.top - ACTION_BUTTONS_HEIGHT;
    left = rightCoordinate - ACTION_BUTTONS_WIDTH;
  } else {
    left = rightCoordinate;
  }

  return { top: Math.round(top), left: Math.round(left) };
};

export const splitTerms = (items) => {
  const terms = [...items].sort((t1, t2) => t2.freq - t1.freq);

  const firstColumn = terms.slice(0, Math.ceil(terms.length / 2));
  const secondColumn = terms.slice(Math.ceil(terms.length / 2));

  return [firstColumn, secondColumn];
};

/* Function escapes regular expression special chars from string */
export const escapeRegExpSpecialChars = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

export const sortCategoryList = (categoryList, isSearch, filterView) => {
  const categoriesArray = [];

  categoryList.forEach((entry) => {
    if (!entry.NounPhrase) {
      const newCategory = [];
      newCategory.push(entry);
      categoriesArray.push(newCategory);
    } else {
      categoriesArray[categoriesArray.length - 1].push(entry);
    }
  });

  categoriesArray.sort((c1, c2) => {
    if (c1[0].GroupName === NO_LOGICAL_GROUPING) {
      return 1;
    }
    if (c2[0].GroupName === NO_LOGICAL_GROUPING) {
      return -1;
    }

    if (isSearch || filterView) {
      if (c1[0].SearchOccurrences < c2[0].SearchOccurrences) {
        return 1;
      }
      if (c1[0].SearchOccurrences > c2[0].SearchOccurrences) {
        return -1;
      }
      return 0;
    } else {
      if (c1[0].Occurrences < c2[0].Occurrences) {
        return 1;
      }
      if (c1[0].Occurrences > c2[0].Occurrences) {
        return -1;
      }
      return 0;
    }
  });

  return categoriesArray.flat(1);
};

export const areAllDocumentsIgnored = (theme) => {
  for (const document of theme.Documents) {
    if (!document.ignored) return false;
  }

  return true;
};

export const hasIgnoredDocuments = (theme) => {
  if (!theme?.Documents) return false;

  for (const document of theme.Documents) {
    if (document.ignored) return true;
  }

  return false;
};

export const getCheckedNPs = (themes, isSearch, filterView, showAll) => {
  return themes.filter((theme) => {
    if (!theme.NounPhrase) return false;
    if (!theme.checked) return false;
    if (isSearch && !theme.FilteredBySearch) {
      return false;
    }
    if (filterView && !theme.FilteredByFilter) {
      return false;
    }
    if (!showAll && !theme.selected) {
      return false;
    }
    return true;
  });
};
